import { LiveData } from '@toeverything/infra';

import type { Member } from '../entities/members';
import type { MemberSearchStore } from '../stores/member-search';
import { PaginatedSession } from './paginated-session';

interface MemberPage {
  members: Member[];
}

export class MemberSearchSession extends PaginatedSession<Member, MemberPage> {
  readonly PAGE_SIZE = 8;
  readonly searchText$ = new LiveData<string>('');

  /**
   * Public alias for `items$` — preserves the historical name used by
   * existing consumers (`group-members-editor`, etc.).
   */
  readonly result$ = this.items$;

  constructor(
    private readonly store: MemberSearchStore,
    private readonly workspaceId: string
  ) {
    super();
  }

  protected async fetchPage(signal: AbortSignal): Promise<MemberPage> {
    return this.store.getMembersByEmailOrName(
      this.workspaceId,
      this.searchText$.value || undefined,
      this.items$.value.length,
      this.PAGE_SIZE,
      signal
    );
  }

  protected handlePage(page: MemberPage): void {
    this.items$.next([...this.items$.value, ...page.members]);
    this.hasMore$.next(page.members.length === this.PAGE_SIZE);
  }

  protected override resetExtra(): void {
    this.searchText$.setValue('');
  }

  search(searchText?: string) {
    this.reset();
    this.searchText$.setValue(searchText ?? '');
    this.loadMore();
  }
}
